import { render, staticRenderFns } from "./EditTableGold.vue?vue&type=template&id=dc7ad14e"
import script from "./EditTableGold.vue?vue&type=script&lang=js"
export * from "./EditTableGold.vue?vue&type=script&lang=js"
import style0 from "./EditTableGold.vue?vue&type=style&index=0&id=dc7ad14e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports